<template>
  <div class="wrapper">
    <div class="backdrop" :class="{hidden:value}" @click="close"></div>
    <ul class="sidebar" :class="{closed:value}">
      <li class="menu-section-header">Decks</li>
      <li @click="close">
        <router-link to="/standard">
          <font-awesome-icon icon="layer-group" class="sidebar-item-icon"/>Standard
        </router-link>
      </li>
      <li @click="close">
        <router-link to="/fibonacci">
          <font-awesome-icon icon="layer-group" class="sidebar-item-icon"/>Fibonnaci
        </router-link>
      </li>
      <li @click="close">
        <router-link to="/tshirt">
          <font-awesome-icon icon="layer-group" class="sidebar-item-icon"/>T-Shirt Size
        </router-link>
      </li>
      <li @click="close">
        <router-link to="/risk_planning">
          <font-awesome-icon icon="layer-group" class="sidebar-item-icon"/>Risk Planning
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: { value: { default: true } },
  methods: {
    close() {
      this.$emit('input', true);
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

a {
  color: white;
  text-decoration: none;
  font-size: 0.9em;
}

.hidden{
    display: none;
    visibility: hidden;
}

.backdrop{
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  position: fixed;
  background: none;
}

.sidebar {
  width: 200px;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  position: fixed;
  text-align: left;
  background-color: #212121;
  box-shadow: 2px 2px 3px rgb(44, 44, 44);
  transition: left 0.4s ease-out;
}

.sidebar.closed {
  left: -200px;
  transition: left 0.4s ease-out;
}

ul > li {
  color: white;
  width: 100%;
  list-style-type: none;
  text-align: left;
  border-bottom: 1px solid black;
}

ul > li > a {
  padding: 20px 10px;
  display: block;
  width: 100%;
}

ul > li:hover {
  background-color: gray;
}

.router-link-active {
  color: white;
  text-decoration: none;
  display: block;
  width: 100%;
  background-color: rgb(44, 44, 44);
  font-weight: bold;
}

.menu-section-header {
  background-color: rgb(44, 44, 66);
  font-size: 1.1em;
  font-weight: bold;
  padding-left: 3px;
}

.sidebar-item-icon {
  margin-right: 8px;
}
</style>
